export const e2eDashboardData = {
  logSource: "docs/e2e-test-log.md",
  environment: [
    { label: "Frontend", value: "http://localhost:3000" },
    { label: "API", value: "Dev HTTP API, DDB_TABLE_PREFIX=dev" },
    { label: "Auth", value: "Cognito owner account support@armorysync.com" },
    { label: "Payments", value: "Stripe sandbox direct charges with embedded Connect components" }
  ],
  nextTests: [
    {
      title: "Canceled and failed checkout paths",
      detail: "Canceled membership, reservation, and event sessions should leave RangeGrid records in a clear recoverable state."
    },
    {
      title: "Owner reviews reservation activity",
      detail: "The owner Resources dashboard should show member-created bookings, conflicts, exports, check-in, and cancellation history."
    }
  ],
  runs: [
    {
      id: "owner-membership-management-lifecycle",
      date: "2026-05-18",
      scenario: "Owner Membership Management Lifecycle",
      area: "Membership",
      role: "Owner",
      status: "passed",
      range: "E2E Stripe Components 202605171803",
      account: "support@armorysync.com",
      summary: "Manually added a member, edited profile/contact notes, suspended access, reactivated access, and archived the member as the owner remove path from the Members section.",
      verifications: [
        "Manual member creation persists through the deployed API",
        "Members tab opens the member detail panel in place",
        "Owner can edit full name, email, phone, and internal notes",
        "Suspend creates an active suspension banner and status history entry",
        "Reactivate clears the suspension and records the transition",
        "Archive works as the audit-preserving remove path",
        "Profile and status update routes are registered in API Gateway"
      ],
      evidence: [
        "docs/e2e-artifacts/membership-management-created-2026051868352.png",
        "docs/e2e-artifacts/membership-management-suspended-2026051868352.png",
        "docs/e2e-artifacts/membership-management-archived-2026051868352.png"
      ],
      followUps: [
        "Consider renaming remove actions to Archive/Restore to make the audit-preserving behavior explicit.",
        "Add a compact member detail drawer once member records become denser."
      ]
    },
    {
      id: "owner-console-ui-system-pass",
      date: "2026-05-17",
      scenario: "Owner Console UI System Pass",
      area: "Console UI",
      role: "Owner",
      status: "passed",
      range: "E2E Stripe Components 202605171803",
      account: "support@armorysync.com",
      summary: "Applied the shared AWS-console-style section pattern across Membership, Resources, Events, Donations, Payments, Settings, and Access, then browser-verified representative workflow tabs.",
      verifications: [
        "Membership separates Setup, Reviews, Plans, and Members",
        "Resources keeps Schedule, Inventory, Access restrictions, Availability blocks, Availability check, and Reservations separated",
        "Events separates Setup, Catalog, and Roster",
        "Donations separates Settings, Manual entry, and History",
        "Payments separates Overview, Stripe workspace, Events, and Receipts",
        "Settings separates Profile, Hours, and Branding",
        "Access separates People and Role matrix",
        "Donations handles a null summary payload after newly enabling the app",
        "Membership review actions no longer clip horizontally"
      ],
      evidence: [
        "docs/e2e-artifacts/ui-system-membership-reviews-2026-05-17.png",
        "docs/e2e-artifacts/ui-system-membership-plans-2026-05-17.png",
        "docs/e2e-artifacts/ui-system-resources-restrictions-2026-05-17.png",
        "docs/e2e-artifacts/ui-system-events-catalog-2026-05-17.png",
        "docs/e2e-artifacts/ui-system-donations-history-2026-05-17.png",
        "docs/e2e-artifacts/ui-system-payments-stripe-2026-05-17.png",
        "docs/e2e-artifacts/ui-system-settings-hours-2026-05-17.png",
        "docs/e2e-artifacts/ui-system-access-roles-2026-05-17.png"
      ],
      followUps: [
        "Replace typed qualification keys with catalog pickers.",
        "Continue reducing dense filter panels into progressive filter drawers when data volume grows."
      ]
    },
    {
      id: "resources-console-ui-separation",
      date: "2026-05-17",
      scenario: "Resources Console UI Separation",
      area: "Resources",
      role: "Owner",
      status: "passed",
      range: "E2E Stripe Components 202605171803",
      account: "support@armorysync.com",
      summary: "Converted the Resources app from a long mixed workflow into AWS-console-style section tabs for Schedule, Inventory, Access restrictions, Availability blocks, Availability check, and Reservations.",
      verifications: [
        "Summary metrics remain visible above workflow tabs",
        "Access restrictions tab isolates restriction management",
        "Reservations tab isolates booking management",
        "Inventory tab remains usable on mobile",
        "No browser page errors during visual smoke"
      ],
      evidence: [
        "docs/e2e-artifacts/resources-tabbed-access-restrictions-desktop-2026-05-17.png",
        "docs/e2e-artifacts/resources-tabbed-reservations-desktop-2026-05-17.png",
        "docs/e2e-artifacts/resources-tabbed-inventory-mobile-2026-05-17.png"
      ],
      followUps: [
        "Apply the same section-tab pattern to Membership so plans, applicants, qualification requests, and member records are not mixed together.",
        "Replace typed qualification keys with a catalog picker in Resources."
      ]
    },
    {
      id: "qualification-gated-reservations-and-resource-access-restrictions",
      date: "2026-05-17",
      scenario: "Qualification-Gated Reservations And Resource Access Restrictions",
      area: "Resources + Membership",
      role: "Owner + Member",
      status: "passed",
      range: "E2E Stripe Components 202605171803",
      account: "rangegrid-e2e-qualified-20260517@dev.rangegrid.local",
      summary: "Created, updated, cleared, and reapplied a resource qualification gate; verified the member was blocked, requested steel_target, owner approved it, and the member then reserved E2E Lane 2.",
      verifications: [
        "Owner Resources has a dedicated Access restrictions panel",
        "Restriction create, update, and clear actions persist through the deployed API",
        "Member portal blocks gated lane reservations before approval",
        "Member submits qualification request with inline notes instead of a browser prompt",
        "Owner qualification queue shows and approves the pending request",
        "Approved member can reserve the gated lane"
      ],
      evidence: [
        "docs/e2e-artifacts/owner-resource-access-restriction-01-created-2026-05-17.png",
        "docs/e2e-artifacts/owner-resource-access-restriction-03-cleared-2026-05-17.png",
        "docs/e2e-artifacts/member-qualification-gate-01-blocked-2026-05-17.png",
        "docs/e2e-artifacts/owner-qualification-request-02-approved-2026-05-17.png",
        "docs/e2e-artifacts/member-qualification-gate-04-reserved-2026-05-17.png"
      ],
      followUps: [
        "Split Resources into clearer service subpages or tabs for inventory, restrictions, blocks, and reservations.",
        "Add a qualification-key picker sourced from the membership catalog instead of requiring typed keys."
      ]
    },
    {
      id: "waiver-expiration-and-member-onboarding",
      date: "2026-05-17",
      scenario: "Waiver Expiration And Member Onboarding",
      area: "Membership",
      role: "Owner + Member",
      status: "passed",
      range: "E2E Stripe Components 202605171803",
      account: "rangegrid-e2e-waiver-202605172130@dev.rangegrid.local",
      summary: "Configured an annual waiver, uploaded a waiver document, added onboarding qualification steps, signed as a member, submitted responses, approved from the owner queue, and verified active member status.",
      verifications: [
        "Owner form includes waiver expiry cadence",
        "Waiver acknowledgement stores and displays an expiration date",
        "No-fee public signup creates a pending member record immediately",
        "Member submits all onboarding responses",
        "Owner review queue shows completed waiver, completed prequalification, response text, and approval action",
        "No-fee payment history reads No payment required"
      ],
      evidence: [
        "docs/e2e-artifacts/owner-waiver-onboarding-config-2026-05-17.png",
        "docs/e2e-artifacts/owner-waiver-onboarding-03-approved-2026-05-17.png",
        "docs/e2e-artifacts/member-waiver-onboarding-04-active-2026-05-17.png",
        "docs/e2e-artifacts/build-e2e-dashboard-waiver-update-2026-05-17.png"
      ],
      followUps: [
        "Run qualification-gated reservation request and approval.",
        "Add renewal reminder behavior for waivers nearing expiration."
      ]
    },
    {
      id: "paid-member-checkout-and-reservations",
      date: "2026-05-17",
      scenario: "Paid Member Checkout And Reservations",
      area: "Membership + Resources",
      role: "Member",
      status: "passed",
      range: "E2E Stripe Components 202605171803",
      account: "rangegrid-e2e-paid-202605171959@dev.rangegrid.local",
      summary: "Bought a paid membership through Stripe Checkout, reconciled it into RangeGrid, approved the member, created owner-managed lanes, and booked two member reservations from the separate member portal.",
      verifications: [
        "Member portal is separate from the owner console at /r/:slug",
        "Stripe Checkout return creates member-visible payment history and receipts",
        "Owner-created lanes appear in the member reservation form",
        "Two no-fee lane reservations are confirmed and the active reservation limit shows 2 of 2",
        "Disabled Events no longer cause member portal API errors"
      ],
      evidence: [
        "docs/e2e-artifacts/member-paid-membership-final-03-completed-2026-05-17.png",
        "docs/e2e-artifacts/owner-create-lanes-03-created-2026-05-17.png",
        "docs/e2e-artifacts/member-reservation-05-final-verified-2026-05-17.png"
      ],
      followUps: [
        "Test cancel and reschedule from the member portal.",
        "Verify owner Resources views show the member-created bookings clearly."
      ]
    },
    {
      id: "stripe-test-kyc-completion",
      date: "2026-05-17",
      scenario: "Stripe Test KYC Completion",
      area: "Payments",
      role: "Owner",
      status: "passed",
      range: "E2E Stripe Components 202605171803",
      account: "acct_1TY92J4YuUBkfLMs",
      summary: "Completed the connected-account readiness flow in Stripe test mode. RangeGrid now shows the account as connected with charges and payouts enabled.",
      verifications: [
        "charges_enabled is true",
        "payouts_enabled is true",
        "card_payments and transfers are active",
        "requirements.currently_due is empty",
        "RangeGrid Payments page shows Connected, Charges Enabled, and Payouts Enabled"
      ],
      evidence: [
        "docs/e2e-artifacts/stripe-kyc-rangegrid-ready-2026-05-17.png",
        "docs/e2e-artifacts/stripe-connect-react-components-2026-05-17.png"
      ],
      followUps: [
        "Automate the full embedded Stripe form only where Stripe's sandbox UI remains stable enough for repeatable browser automation."
      ]
    },
    {
      id: "owner-opens-embedded-stripe-components",
      date: "2026-05-17",
      scenario: "Owner Opens Embedded Stripe Components",
      area: "Payments",
      role: "Owner",
      status: "passed",
      range: "E2E Stripe Components 202605171803",
      account: "acct_1TY92J4YuUBkfLMs",
      summary: "Verified RangeGrid renders Stripe's official embedded React Connect components inside the owner Payments page.",
      verifications: [
        "Account Session endpoint returns a client secret and publishable key",
        "Embedded onboarding renders inside RangeGrid",
        "No custom iframe wrapper is used for Stripe Connect"
      ],
      evidence: [
        "docs/e2e-artifacts/stripe-connect-react-components-2026-05-17.png"
      ],
      followUps: []
    },
    {
      id: "connect-creation-publish-guard",
      date: "2026-05-17",
      scenario: "Owner Connect Creation Retest After Stripe Setup",
      area: "Payments",
      role: "Owner",
      status: "passed",
      range: "test",
      account: "acct_1TXzxe7Ec7veMoBn",
      summary: "Confirmed paid public memberships stay blocked until Stripe is ready, then created a range-specific connected account through RangeGrid.",
      verifications: [
        "Paid public membership publish before Connect returns 409",
        "Account Session creation returns 201 after platform setup is correct",
        "Range payment state persists connectedAccountId and pending readiness flags",
        "Publishing remains blocked while onboarding is incomplete"
      ],
      evidence: [
        "docs/e2e-test-log.md"
      ],
      followUps: []
    },
    {
      id: "owner-creates-membership-types",
      date: "2026-05-17",
      scenario: "Owner Creates Membership Types",
      area: "Membership",
      role: "Owner",
      status: "passed",
      range: "E2E Complete Range 202605170629",
      account: "Stripe connected account not ready during this pass",
      summary: "Created annual, monthly family, lifetime, and day-pass plans. Verified critical Stripe price updates create a new Price and deactivation disables Product and Price.",
      verifications: [
        "Plan category is visible in the owner form",
        "Paid public publishing is blocked when Stripe is not ready",
        "Critical price and term updates keep history while creating a new active Stripe Price",
        "Deactivate action makes the RangeGrid plan inactive and disables synced Stripe catalog records"
      ],
      evidence: [
        "docs/e2e-screenshots/2026-05-17-membership-types-catalog.png",
        "docs/e2e-screenshots/2026-05-17-membership-types-actions.png"
      ],
      followUps: [
        "Run the same membership creation flow after Stripe is charge-enabled, then buy one from the public page."
      ]
    },
    {
      id: "owner-creates-first-range",
      date: "2026-05-17",
      scenario: "Owner Creates First Range",
      area: "Range setup",
      role: "Owner",
      status: "passed",
      range: "E2E Complete Range 202605170629",
      account: "support@armorysync.com",
      summary: "Verified a signed-in owner can create a range and reach the owner console readiness surfaces.",
      verifications: [
        "New range record is created",
        "Owner can open applications and setup areas",
        "Readiness signals identify missing setup instead of hiding it"
      ],
      evidence: [
        "docs/e2e-screenshots/2026-05-17-create-range-applications.png"
      ],
      followUps: [
        "Keep auditing whether range records need additional compliance, policy, and customer-service fields before public checkout."
      ]
    },
    {
      id: "legacy-connect-onboarding",
      date: "2026-05-17",
      scenario: "Owner Starts Stripe Connect Onboarding",
      area: "Payments",
      role: "Owner",
      status: "resolved",
      range: "E2E Complete Range 202605170629",
      account: "Previous sandbox key pairing",
      summary: "Initial Connect attempts exposed platform setup and key-pairing problems. Later passes fixed the app behavior and Stripe sandbox configuration.",
      verifications: [
        "Backend now returns clear 409 messages for platform setup blockers",
        "Payments page exposes owner actions for Connect and refresh",
        "Later embedded component and KYC runs supersede this blocked pass"
      ],
      evidence: [
        "docs/e2e-test-log.md"
      ],
      followUps: []
    }
  ]
};
